import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { Layout, NavDrawer, Panel } from 'react-toolbox/lib/layout'
import T from 'i18n-react'

import {
  ADMIN_PARTS_LIBRARY,
  FETCH_PARTS,
} from './constants'
import loadSagas from './sagas'
import { withCollapse } from 'components/fulcrum/collapse/Collapse'

import Heading from './Heading'
import CSSModules from 'helpers/CSSModulesUtil'
import injectSagas from 'helpers/injectSagas'
import MainPanel from './MainPanel'

import Link from './Link'
import List from './List'
import styles from './styles.scss'
import dialogHoc from 'containers/Async/AsyncDialog'

import {
  fetchParts,
  postParts,
} from './actions'
import {
  isLoadingSelector,
  partsSelector
} from './selectors'

const mapStateToProps = (state) => {
  return {
    parts: partsSelector(state),
    isLoading: isLoadingSelector(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    handleMount: () => dispatch(fetchParts()),
    postParts: (partName, partData, partSettingName) => dispatch(postParts(partName, partData, partSettingName))
  }
}

const AsyncPartDialog = dialogHoc([FETCH_PARTS])
class AdminPartsLibraryPage extends Component {
  componentDidMount() {
    this.props.handleMount()
  }

  render() {
    const { parts, isLoading } = this.props
    const links = parts && Object.keys(parts).map((part, index) => {
      return (
        <Link
          key={index}
          label={T.translate(`containers.admin.partsLibrary.${part}.title`)}
          containerId='scrollContainer'
          to={part}
        />
      )
    })
    return (
      <Layout theme={styles}>
        <NavDrawer pinned scrollY theme={styles}>
          <Heading>
            Navigation
          </Heading>
          <List>
            {!isLoading && links}
          </List>
        </NavDrawer>
        <Panel theme={styles}>
          <MainPanel {...this.props} />
        </Panel>
        <AsyncPartDialog title='Loading Parts ...'/>
      </Layout>
    )
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withStyles = CSSModules(styles)
const withSagas = injectSagas({ [ADMIN_PARTS_LIBRARY]: loadSagas })
const enhance = compose(
  withConnect,
  withCollapse,
  withSagas,
  withStyles
)

export default enhance(AdminPartsLibraryPage)
